/**
 * Template: Product Gift Card
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

 import {debounce, on} from '~/helpers/utils';
 import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';
 import breakpoints from '../helpers/breakpoints';
 import Accordion from '~/components/accordion';
 import ProductForm from '~/components/product-form';
 import ProductGallery from '~/components/product-gallery';
 import FeatureCarousel from '~/components/feature-carousel';
 import NavigatorShare from '~/components/navigator-share';
 import Toggle from '~/components/toggle';
 import SimpleBar from 'simplebar';
 import 'simplebar/dist/simplebar.css';
 
 import '../sections/image-video-hero';
 
 /**
  * DOM selectors.
  */
 const selectors = {
   asideScrollable: '[js-product="asideScrollable"]',
   swatchContainer: '[js-product-form="swatch-container"]',
 };
 
 
 
 
 
 
 document.addEventListener('DOMContentLoaded', () => {
 
   /**
    * DOM node selectors.
    */
   const nodeSelectors = {
     asideScrollable: document.querySelector(selectors.asideScrollable),
     swatchContainer: document.querySelector(selectors.swatchContainer),
   };

 
   FeatureCarousel().init();
 
   ProductGallery().init();
 
   Accordion('#productAccordion', {
     singleOpen: false,
   }).init();
 
   const activeAsideScrollable = new SimpleBar(nodeSelectors.asideScrollable, {
     autoHide: false,
   });
 
 
   on('resize', debounce(activeAsideScrollable.recalculate(), 250));
 
   NavigatorShare().init();
 
   /**
    * Check if product form has swatches.
    */
   function hasSwatches() {
     return Boolean(nodeSelectors.swatchContainer);
   }
 
   ProductForm({
     container: 'container',
     enableSwatches: hasSwatches(),
   }).init();
 });
 
 
 /**
    * Check if browser window is desktop screen size.
    * @returns {Boolean}
    */
  function isDesktop() {
   return window.matchMedia(`(min-width: ${breakpoints.medium})`).matches;
 }
 
 /**
  * Check the current size of header and push on right side in pdp
  */
   
 
 